import React, { useContext, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import myFunctions from '../../../myFunctions';
import { CurrentSingleContext } from '../../MyContexts/CurrentSingle_Context';
import { RestContext } from '../../MyContexts/Rest_Context';
import SelectImgComp from '../../MySections/ImagesSetter/SelectImgComp';
import SelectImgDelay from '../../MySections/ImagesSetter/SelectImgDelay';
import RichTextComp from '../../MySections/TextEditor/RichText';
import SectItmBtn1Effects from './SectItmBtn1Effects';
import SectItmBtn2Effects from './SectItmBtn2Effects';
import SectItmmainHeadEffects from './SectItmmainHeadEffects';
import SectItmSmalltxtEffects from './SectItmSmalltxtEffects';

const SectionHead2Btns = (props) => {

    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);


    const [mainHead, setMainHead] = useState(currentSingle.mainHead);
    const [smalltxt, setSmalltxt] = useState(currentSingle.smalltxt);


    const [btn1Txt, setBtn1Txt] = useState(currentSingle.btn1Txt);
    const [btn2Txt, setBtn2Txt] = useState(currentSingle.btn2Txt);
    const [btn1Lnk, setBtn1Lnk] = useState(currentSingle.btn1Lnk);
    const [btn2Lnk, setBtn2Lnk] = useState(currentSingle.btn2Lnk);

    const [blockColor, setBlockColor] = useState(currentSingle.blockColor);
    const [blockLeft, setBlockLeft] = useState(currentSingle.blockLeft);
    const [blockTop, setBlockTop] = useState(currentSingle.blockTop);
    const [blockTransparent, setBlockTransparent] = useState(currentSingle.blockTransparent);
    const [blockWidth, setBlockWidth] = useState(currentSingle.blockWidth);
    const [blockHeight, setBlockHeight] = useState(currentSingle.blockHeight);



    useEffect(() => {

    }, [])
    return (
        <>
            <div className="form-row tabsInputs ">
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>רוחב קובייה (%)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"50"} value={blockWidth} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockWidth = e.target.value; setBlockWidth(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>גובה קובייה (%)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"50"} value={blockHeight} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockHeight = e.target.value; setBlockHeight(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>צבע רקע קובייה</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"#fffff"} value={blockColor} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockColor = e.target.value; setBlockColor(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>מיקום משמאל (%)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"25"} value={blockLeft} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockLeft = e.target.value; setBlockLeft(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>מיקום מלמעלה (%)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"25"} value={blockTop} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockTop = e.target.value; setBlockTop(e.target.value) }} />

                    </div>
                </div>
                <div className={"col-md-2 mb-1 onLeft"}>
                    <label>שקיפות (0.1 - 1)</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"0.7"} value={blockTransparent} style={{ direction: "ltr" }}
                            onChange={(e) => { currentSingle.blockTransparent = e.target.value; setBlockTransparent(e.target.value) }} />

                    </div>
                </div>

            </div>
            <div className="form-row tabsInputs ">
                <div className={"col-md-8 mb-2 onRight"}>
                    <label htmlFor={"validationCustom01"}>כותרת ראשית</label>
                    <div className={"input-group"}>
                        <input type={"text"} className={"form-control"} id={"validationCustom01"} placeholder={"כותרת ראשית"} value={mainHead}
                            onChange={(e) => { currentSingle.mainHead = e.target.value; setMainHead(e.target.value) }} required />

                    </div>
                </div>
                <SectItmmainHeadEffects thePage={props.thePage} theSectionUpdate={(key, val) => props.theSectionUpdate(key, val)} />
            </div>
            <div className="form-row tabsInputs">

                <div className={"col-md-8 mb-2 onRight"}>

                    <label htmlFor={"validationCustom03"}>טקסט</label>
                    <div className={"input-group"}>
                        <RichTextComp firstText={smalltxt}
                            saveEditorTxt={(content) => { currentSingle.smalltxt = content; setSmalltxt(content) }} />
                    </div>
                </div>

                <SectItmSmalltxtEffects thePage={props.thePage} theSectionUpdate={(key, val) => props.theSectionUpdate(key, val)} />


            </div>
            <div className="form-row tabsInputs">
                <div className={"col-md-12 mb-2"}>
                    <label className={"fullRow"} htmlFor={""}>כפתור ימין</label>

                    <SectItmBtn1Effects thePage={props.thePage} theSectionUpdate={(key, val) => props.theSectionUpdate(key, val)} />

                    <div className={"col-md-6 mb-2 onRight"}>
                        <div className={"col-md-12 mb-2 onRight"}>
                            <label htmlFor={"validationCustom03"}>קישור הכפתור</label>
                            <div className={"input-group"}>
                                <input type={"text"} className={"form-control"} id={"validationCustom03"} placeholder={"טקסט על הכפתור"} value={btn1Lnk}
                                    onChange={(e) => { currentSingle.btn1Lnk = e.target.value; setBtn1Lnk(e.target.value) }} />
                            </div>
                        </div>
                        <div className={"col-md-12 mb-1 onRight"}>
                            <label htmlFor={"validationCustom04"}>טקסט על הכפתור</label>
                            <div className={"input-group"}>
                                <input type={"text"} className={"form-control"} id={"validationCustom04"} placeholder={"טקסט על הכפתור"} value={btn1Txt}
                                    onChange={(e) => { currentSingle.btn1Txt = e.target.value; setBtn1Txt(e.target.value) }} />
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <div className="form-row tabsInputs ">
                <div className={"col-md-12 mb-2"}>
                    <label className={"fullRow"} htmlFor={""}>כפתור שמאל</label>
                    <SectItmBtn2Effects thePage={props.thePage} theSectionUpdate={(key, val) => props.theSectionUpdate(key, val)} />

                    <div className={"col-md-6 mb-2 onRight"}>


                        <div className={"col-md-12 mb-2 onRight"}>
                            <label htmlFor={"validationCustom05"}>קישור הכפתור</label>
                            <div className={"input-group"}>
                                <input type={"text"} className={"form-control"} id={"validationCustom05"} placeholder={"טקסט על הכפתור"} value={btn2Lnk}
                                    onChange={(e) => { currentSingle.btn2Lnk = e.target.value; setBtn2Lnk(e.target.value) }} />
                            </div>
                        </div>

                        <div className={"col-md-12 mb-2 onRight"}>
                            <label htmlFor={"validationCustom06"}>טקסט על הכפתור</label>
                            <div className={"input-group"}>
                                <input type={"text"} className={"form-control"} id={"validationCustom06"} placeholder={"טקסט על הכפתור"} value={btn2Txt}
                                    onChange={(e) => { currentSingle.btn2Txt = e.target.value; setBtn2Txt(e.target.value) }} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>


    );
}

export default SectionHead2Btns;